import { useContext } from 'react'

import { Context, RegisterContext } from '../contexts/RegisterContext'

export default function useRegisterContext(): Context {
  const contextValue = useContext(RegisterContext)

  if (contextValue === null) {
    throw new Error('RegisterContext not configured.')
  }

  return contextValue
}
